import React from "react";
import { Form, Input, Row, Col } from "antd";
import PinCodeValidator from "../PincodeValidator";

const ClientBusinessEdit = ({ getData }) => {
  return (
    <Row gutter={16} className="global-form-row">
      <Col span={24}>
        <Form.Item name="street" label="Billing Address">
          <Input.TextArea rows={4} placeholder="Enter complete address" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <PinCodeValidator
          formName={"pincode"}
          value={
            getData?.addresses?.find((e) => e?.type === "COLLECTION")?.pincode
          }
        />
      </Col>
    </Row>
  );
};

export default ClientBusinessEdit;
